import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import {
  AppShell,
  Button,
  createTheme,
  Grid,
  Group,
  useMantineColorScheme,
} from "@mantine/core";
import { useAuthState } from "react-firebase-hooks/auth";
import { MantineProvider } from "@mantine/core";
import { Logo } from "./Logo";
import { IconBulb } from "@tabler/icons-react";
import { auth, loadData, signInUser, signOutUser } from "./firebase";
import { useEffect, useState } from "react";
import { AppContext } from "./Context";
import { ProjectorV2 } from "./frontend/v2/Projector/Projector";
import { Notification } from "./types";
import { CashflowItems } from "./backend/types-v2";
import { dataV2 } from "./backend/data-v2";

function App() {
  const theme = createTheme({});

  return (
    <MantineProvider theme={theme} defaultColorScheme="dark">
      <InnerApp />
    </MantineProvider>
  );
}

function InnerApp() {
  const { setColorScheme, colorScheme } = useMantineColorScheme();
  const [useMockData, setUseMockData] = useState<boolean>(
    process.env.NODE_ENV === "development" && true,
  );

  const [userData, setUserData] = useState<CashflowItems>([]); // move to new format
  const [user] = useAuthState(auth);

  useEffect(() => {
    const load = async () => {
      if (useMockData) {
        const mockItems = dataV2;
        setUserData(mockItems);
      } else {
        const res = await loadData();

        if (res) {
          setUserData(res);
        }
      }
    };

    load();
  }, [user, useMockData]);

  const [notification, setNotification] = useState<Notification | null>(null);

  return (
    <AppContext.Provider
      value={{ userData, setUserData, setNotification, notification }}
    >
      <AppShell header={{ height: 60 }} padding="md">
        <AppShell.Header>
          <Group h="100%" px="md" justify="space-between">
            <Logo size={30} />
            <Group>
              <Button
                onClick={() =>
                  colorScheme === "light"
                    ? setColorScheme("dark")
                    : setColorScheme("light")
                }
              >
                <IconBulb />
              </Button>
              {false && process.env.NODE_ENV === "development" && (
                <Button onClick={() => setUseMockData(!useMockData)}>
                  Use {useMockData ? "real" : "mock"} data
                </Button>
              )}
              {user ? (
                <Button variant="secondary" onClick={signOutUser}>
                  Logout
                </Button>
              ) : (
                <Button variant="secondary" onClick={signInUser}>
                  Login
                </Button>
              )}
            </Group>
          </Group>
          <Group></Group>
        </AppShell.Header>
        <AppShell.Main>
          <Grid>
            <Grid.Col span={12}>
              <ProjectorV2 items={userData} />
            </Grid.Col>
          </Grid>
        </AppShell.Main>
      </AppShell>
    </AppContext.Provider>
  );
}

export default App;
